export const imageShouldBeShortened = (
  pathName: string,
  hasDependents: boolean
): boolean => {
  let result = false;

  if (pathName.includes("eligibility/home")) {
    result = true;
  } else if (pathName.includes("eligibility/more-questions")) {
    result = !hasDependents;
  } else if (pathName.includes("subscriber-info")) {
    result = true;
  } else if (pathName.includes("dob")) {
    result = true;
  }
  return result;
};